<template>
  <div class="row">
    <div class="col-12 form-group" :class="format">
      <label :for="label" class="form-label">{{ label }}</label>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    label: { default: null },
    format: { default: null },
  },
  methods: {},
  mounted() {},
};
</script>